import React from 'react';
import ReactTable from "react-table-6";
import _ from 'lodash';

export const formatComma = val => (
  !isNaN(parseFloat(val))
    ? parseFloat(val).toFixed(2).toString().replace(/\B(?=(?:\d{3})+(?!\d))/g, ',')
    : val
);

interface Props {
  selectedRow?: number | Record<string,any>;
  loading?: boolean;
  data?: object[];
  columns?: object[];
  page?: number;
  pages?: number;
  pageSize?: number;
  style?: Record<string,any>;
  onPageSizeChange?: () => void;
  onPageChange?: () => void;
  onClick?: () => void;
  onEnter?: () => void;
}

export default class PureReactTable extends React.PureComponent<Props,any> {
  constructor() {
    super()
    this.clickTimer = null;
    this.clickCount = 0;
  }

  static defaultProps = {
    loading: false,
    data: [],
    columns: [],
    selectedRow: null,
    onSelect() {},
    onEnter() {},
  };

  render() {
    const {
      height,
      onSelect,
      onEnter,
      selectedRow,
      data,
      getTrProps = () => ({}),
      ...rest
    } = this.props;

    const noId = _.find(data, item => typeof item.id === 'undefined');

    if (noId) {
      throw new Error(`
        Every row should have an 'id' field\n
        got: ${JSON.stringify(noId)}
      `);
    }

    return (
      <ReactTable
        manual
        className='-striped -highlight'
        getTrProps={(state, rowInfo, column, instance) => {
          if (rowInfo && rowInfo.row) {
            const id = rowInfo.original.id;
            const options = getTrProps(state, rowInfo, column, instance);
            let selectedRowId = null;

            if (selectedRow && typeof selectedRow === 'object') {
              selectedRowId = selectedRow.id;
            }
            if (selectedRow && typeof selectedRow === 'number') {
              selectedRowId = selectedRow;
            }
            return {
              ...options,
              onClick: (event, handleOriginal) => {
                if (handleOriginal) {
                  handleOriginal();
                }

                this.clickCount++;
                if (this.clickCount === 1) {
                  this.clickTimer = setTimeout(() => {
                    this.clickCount = 0;
                    // Single Click
                    onSelect(rowInfo.original);
                  }, 400)
                } else if (this.clickCount === 2) {
                  clearTimeout(this.clickTimer);
                  this.clickCount = 0;
                  // Double Click
                  onEnter(rowInfo.original);
                }
              },
              onDoubleClick(event, handleOriginal) {
                if (handleOriginal) {
                  handleOriginal();
                }
                onEnter(rowInfo.original);
              },
              onKeyUp(event) {
                // TODO: handle keyboard navigation
              },
              className: id === selectedRowId ? 'selected' : '',
            };
          }
          return {};
        }}
        data={data}
        {...rest}
      />
    );
  }
}


export const alignRight = val => <div style={{textAlign: 'right'}}>{val}</div>;
export const alignCenter = val => <div style={{textAlign: 'center'}}>{val}</div>;
export const formatPrice = val => <div style={{textAlign: 'right'}}>{formatComma(val)}</div>;
